var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row form-group text-area-row" }, [
    _c(
      "span",
      { class: [_vm.labelClass, "col-form-label"] },
      [_vm._t("label")],
      2
    ),
    _vm._v(" "),
    _c("div", { class: [_vm.valueClass, "col-form-label"] }, [
      _c(
        "span",
        { class: { "float-right": _vm.alignRight } },
        [_vm._t("default")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }